/**
 * Contains a hardcoded list of built-in html elements, so we can easily
 * determine if a node should be handled as such.
 */
export const htmlElements = {
    a: true,
    b: true,
    blockquote: true,
    br: true,
    div: true,
    em: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    i: true,
    iframe: true,
    li: true,
    ol: true,
    p: true,
    span: true,
    strong: true,
    sub: true,
    sup: true,
    table: true,
    tbody: true,
    td: true,
    th: true,
    thead: true,
    tr: true,
    u: true,
    ul: true,
    wbr: true,
};
